import { defineComponent, computed } from "vue";
import ArrowStrokeTurnPageIcon from "../../common/icons/ArrowStrokeTurnPageIcon.vue.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import StreamList from "../common/StreamList/index.vue.mjs";
import { StreamPlayMode, StreamPlayQuality } from "../../../services/manager/mediaManager.mjs";
import useMultiStreamViewHook from "./useMultiStreamViewHook.mjs";
import { storeToRefs } from "pinia";
import { useBasicStore } from "../../../stores/basic.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MultiStreamViewPC",
  props: {
    maxColumn: null,
    maxRow: null,
    fillMode: null,
    excludeStreamInfoList: null
  },
  emits: ["stream-view-dblclick"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const {
      column,
      row,
      totalPageNumber,
      isEqualPointsLayout,
      renderStreamInfoList,
      equalPointsLayoutStreamList,
      currentPageIndex
    } = useMultiStreamViewHook(props);
    const basicStore = useBasicStore();
    const { showRoomTool } = storeToRefs(basicStore);
    const streamInfoList = computed(() => {
      if (isEqualPointsLayout.value) {
        return equalPointsLayoutStreamList.value[currentPageIndex.value];
      }
      return renderStreamInfoList.value;
    });
    function handleStreamDblclick(streamInfo) {
      emits("stream-view-dblclick", streamInfo);
    }
    const showTurnPageControl = computed(
      () => isEqualPointsLayout.value && totalPageNumber.value > 1
    );
    const showTurnPageLeftArrow = computed(
      () => isEqualPointsLayout.value && currentPageIndex.value > 0
    );
    const showTurnPageRightArrow = computed(
      () => isEqualPointsLayout.value && currentPageIndex.value < totalPageNumber.value - 1
    );
    function handleTurnPageLeft() {
      currentPageIndex.value = currentPageIndex.value - 1;
    }
    function handleTurnPageRight() {
      currentPageIndex.value = currentPageIndex.value + 1;
    }
    return { __sfc: true, props, column, row, totalPageNumber, isEqualPointsLayout, renderStreamInfoList, equalPointsLayoutStreamList, currentPageIndex, basicStore, showRoomTool, streamInfoList, emits, handleStreamDblclick, showTurnPageControl, showTurnPageLeftArrow, showTurnPageRightArrow, handleTurnPageLeft, handleTurnPageRight, ArrowStrokeTurnPageIcon, SvgIcon, StreamList, StreamPlayMode, StreamPlayQuality };
  }
});
export {
  _sfc_main as default
};
